import { render, staticRenderFns } from "./MisPasajeros.vue?vue&type=template&id=baa35ce2"
import script from "./MisPasajeros.vue?vue&type=script&lang=js"
export * from "./MisPasajeros.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports